import React, { useState } from 'react';
import { getFormInputClassNames } from '../sharedFormFunctions';
import './_radioGroup.scss';

const styles = (cN: string) => {
  const mapped = cN.split(' ');
  return mapped.join(' ').trim();
};

export type RadioOption = {
  id: string | number;
  text: string;
};

interface IRadioGroupProps {
  selectedOptionId?: number | string;
  questionText: string;
  options: RadioOption[];
  onChange?: (e: any) => void;
  invalid?: boolean;
  disabled?: boolean;
  invalidText?: string | null;
  id: string;
  layout?: 'vertical' | 'horizontal';
}

const RadioGroup = React.forwardRef((props: IRadioGroupProps, ref: any) => {
  const [value, setValue] = useState(props.selectedOptionId?.toString());
  const { disabled } = props;
  const optionIsSelected = (option: any) => {
    // @ts-ignore
    return option.toString() === value;
  };

  return (
    <fieldset
      className={styles(getFormInputClassNames('c_radio-group', props))}
    >
      {props.questionText && props.questionText.length > 0 && (
        <legend className={styles('c_radio-group__question-text')}>
          {/* // @ts-ignore */}
          {props.questionText}
        </legend>
      )}
      {props.invalid && (
        <div className={styles('c_radio-group__invalid-text')}>
          {props.invalidText}
        </div>
      )}
      <div
        className={
          props.layout === 'horizontal'
            ? styles('c_radio-group__horizontal')
            : styles('c_radio-group__vertical')
        }
      >
        {props.options.map((option) => (
          <span
            key={`radioLabelKey__id${option.id}_${props.id}`}
            className={styles('c_radio-group-option')}
          >
            <span
              className={
                disabled
                  ? styles('c_radio-group-option__check-area--disabled')
                  : styles('c_radio-group-option__check-area')
              }
            >
              {optionIsSelected(option.id) && (
                <span
                  className={
                    disabled
                      ? styles('c_radio-group-option__selected-dot--disabled')
                      : styles('c_radio-group-option__selected-dot')
                  }
                />
              )}
            </span>
            <input
              name={`${props.id}`}
              disabled={disabled}
              type='radio'
              ref={(r) => {
                if (ref) {
                  ref(r);
                }
                if (r) {
                  r.checked = optionIsSelected(option.id);
                }
              }}
              value={option.id}
              defaultChecked={optionIsSelected(option.id)}
              onChange={(e: any) => {
                setValue(option.id.toString());
                if (props.onChange) props.onChange(e.target.value);
              }}
              id={`${option.text}${props.id}`}
            />
            <label
              htmlFor={`${option.text}${props.id}`}
              className={
                disabled
                  ? styles('c_radio-group-option__text--disabled')
                  : styles('c_radio-group-option__text')
              }
            >
              {option.text}
            </label>
          </span>
        ))}
      </div>
    </fieldset>
  );
});

// RadioGroup.propTypes = {
//   questionText: PropTypes.string,
//     options: PropTypes.arrayOf(PropTypes.shape({ // eslint-disable-line
//       id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
//       text: PropTypes.string.isRequired
//     })
//   ).isRequired,
//   selectedOptionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
//     .isRequired,
//   onChange: PropTypes.func.isRequired,
//     className: PropTypes.string // eslint-disable-line
// };

export { RadioGroup };
